import * as React from "react";
import * as ReactDOM from "react-dom";
import "../../../../components/common";
import "../../../../components/Header/index.css";
import "./style.css";
import config from "../../../../utils/config";
import request from "../../../../utils/request";
import { GetQueryString } from "../../../../utils/utils"
import { navigateEn } from '../../../../utils/utils'
import "../../../../components/shop/common";
import Language from "../../../../components/Header/language";

interface InterProps {
    url ? : string;
    shopInfo: any
}

export default class Header extends React.Component < InterProps, any > {
    private navRef;
    constructor(props: any) {
        super(props);
        this.state = {
            infoData: "", // 头部信息
            pathName: "",
            timePoupShow: false, // 显示店铺年限
            isMiniBaiduProgram: (window as any).isMiniBaiduProgram, // 是否在百度小程序中
            shopId: "", // 店铺id
            shopDomain: "", // 店铺域名
            modelsId: "", // 模板id
            styleConfig: {},
            styleShow: false,
            searchValue: decodeURIComponent(GetQueryString("keyword" || "")),
        };
        this.navRef = React.createRef();
    }

    public componentDidUpdate(prevProps) {
        if (this.props.shopInfo.shop_id !== prevProps.shopInfo.shop_id) {
            // 如果 shopInfo 发生了变化，执行某些操作
            this.getData()
            // 在这里可以调用相关逻辑，比如更新状态或者发起新的请求等
        }
    }

    public componentDidMount() {
        this.getTopAd();
        // 头部面板控制
        const path = window.location.pathname;

        this.setState({
            pathName: path,
        });
    }

    public componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };

    public render() {
        const state = this.state;
        return (
            <div>
        <header className="main-header">
          <div
            className="shop shop-en"
            style={{
              background: `url(${this.state.topAd || this.state.styleConfig.wap_top_advertising}) center top repeat-x`,
              color: "#666",
            }}
          >
            <div className="shop-name">
              <div className="shop-name-title">
                <h2>{state.infoData.shop_name_en}</h2>
              </div>
              <div>
                <p className="header-small-icon">
                  {state.infoData.activity_tag === "1" ? (
                    <img
                      className="label-join"
                      src={require("../../../../assets/images/icon-join.png")}
                    />
                  ) : null}
                  {state.infoData.tags_img &&
                  state.infoData.seller_grade !== "1"
                    ? state.infoData.tags_img.map((v: any, k: number) => {
                        return (
                          <i
                            style={{
                              background: `url(${v}) no-repeat`,
                              backgroundSize: "100%, 100%",
                            }}
                            key={`headerIcon${k}`}
                          />
                        );
                      })
                    : null}
                  {state.infoData.seller_grade !== "1" ? (
                    <span onClick={() => this._showTimePoup()}>
                      {state.infoData.created_at}Years
                    </span>
                  ) : (
                    ""
                  )}
                </p>
              </div>
            </div>
            <Language url={this.props.url} shopInfo={this.props.shopInfo}/>
          </div>
          <div className="search_menu">
            <div className="search-ss">
              <img src={require("../../../../assets/images/msp_05.png")} />
              <input
                type="text"
                name=""
                placeholder="search"
                id="myInput"
                onChange={() => this._search(event)}
                onKeyDown={evt => this.submitSearchForm(evt)}
                value={this.state.searchValue}
              />
            </div>
            <div
              className="nav-layout1"
              style={{ display: this.state.styleShow ? "block" : "none" }}
            >
              <ul
                className={`nav ${this.state.isMiniBaiduProgram ? "row3" : ""}`}
                ref={this.navRef}
              >
                <li>
                  <a
                    style={
                      this.state.styleConfig
                        ? this.getStyle(
                            this.state.styleConfig,
                            state.pathName === "/m/"
                          )
                        : {}
                    }
                    className={
                      state.pathName === "/" ||
                      state.pathName === "/m/"
                        ? "current"
                        : ""
                    }
                    onClick={() => this._push("/m/")}
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    style={
                      this.state.styleConfig
                        ? this.getStyle(
                            this.state.styleConfig,
                            this.isCurrentPath("/classify"),
                          )
                        : {}
                    }
                    className={
                      this.isCurrentPath("/classify") ? "current" : ""
                    }
                    onClick={() => this._push("/m/classify")}
                  >
                    Classify
                  </a>
                </li>
                <li>
                  <a
                    style={
                      this.state.styleConfig
                        ? this.getStyle(
                            this.state.styleConfig,
                            this.isCurrentPath("/offerlist"),
                          )
                        : {}
                    }
                    className={
                      this.isCurrentPath("/offerlist") ? "current" : ""
                    }
                    onClick={() => this._push("/m/offerlist")}
                  >
                    Products
                  </a>
                </li>
                <li>
                  <a
                    style={
                      this.state.styleConfig
                        ? this.getStyle(
                            this.state.styleConfig,
                            this.isCurrentPath("/offerlist"),
                          )
                        : {}
                    }
                    className={
                      this.isCurrentPath("/zx") ? "current" : ""
                    }
                    onClick={() => this._push("/m/zx")}
                  >
                    News
                  </a>
                </li>
                <li>
                  <a
                    style={
                      this.state.styleConfig
                        ? this.getStyle(
                            this.state.styleConfig,
                            this.isCurrentPath("/storeintro"),
                          )
                        : {}
                    }
                    className={
                      this.isCurrentPath("/storeintro") ? "current" : ""
                    }
                    onClick={() => this._push("/m/storeintro")}
                  >
                    About Us
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </header>
        <div
          className="head-dialog"
          style={{ display: this.state.timePoupShow ? "block" : "none" }}
        >
          {`${this.state.infoData.member_type ? this.state.infoData.member_type : ""}： ${this.state.infoData.service_begin}-${this.state.infoData.service_end}`}
        </div>
      </div>
        );
    }

    private getQueryString(name: string) {
        const reg = new RegExp("(^|/?|&)" + name + "=([^&]*)(&|$)", "i");
        const r = decodeURIComponent(location.href).substr(1).match(reg);
        if (r != null) {
            return r[2];
        }
        return null;
    }

    private getData() {
        const data = this.props.shopInfo
        document.title = data.shop_name_en + ' - ibuychem';
        this.setState({
                shopId: data.shop_id || "",
                modelsId: this.getQueryString("modelsId") || data.models_id,
                shopDomain: data.shop_domain || "",
                infoData: data,
            },
            () => {
                this._getStyle();
            },
        );
    }

    // 获取样式
    private async _getStyle() {
        const r = request({
            url: config.PHPAPI + "api/wshop/shop/get-models",
            method: "post",
            data: {
                shopId: this.state.shopId,
                shopDomain: this.state.shopDomain,
                modelsId: this.state.modelsId,
            },
        });

        r.then((res) => {
            if (res.error_code === 0) {
                this.setState({
                    styleConfig: res.data.wap_configuration,
                    styleShow: true,
                });
            }
        });
    }

    private getStyle(data: any, isChecked ? : boolean) {
        const styles: any = {};

        styles.color = data.wap_top_font ? data.wap_top_font : "";
        if (isChecked) {
            styles.color = data.wap_top_font_selected ?
                data.wap_top_font_selected :
                "";
            styles.borderBottomColor = data.wap_bottom_selected ?
                data.wap_bottom_selected :
                "";
        }

        return styles;
    }

    private _showTimePoup() {
        const that = this;
        if (!this.state.timePoupShow) {
            this.setState({
                    timePoupShow: true,
                },
                () => {
                    const timer = setTimeout(function() {
                        that.setState({
                            timePoupShow: false,
                        });
                        clearTimeout(timer);
                    }, 1500);
                },
            );
        }
    }

    private _push(url: string) {
        navigateEn(url)
    }

    // 搜索
    private _search(e: any) {
        this.setState({
            searchValue: e.target.value
        })
    }

    private submitSearchForm(e) {
        if (e.keyCode === 13) {
            const keyword = encodeURIComponent(e.target.value);
            navigateEn(window.location.origin + "/m/offerlist?keyword=" +
                encodeURIComponent(keyword))
        }

    }

    private isCurrentPath(pathName: string) {
        return this.state.pathName.indexOf(pathName) > -1;
    }

    // 获取顶部广告位
    private async getTopAd() {
        const path: any = (window as any).shopId;

        const r = request({
            data: {
                shopDomain: path,
                lanType: 1,
            },
            method: "post",
            url: config.PHPAPI + "api/wshop/shop/special",
        });

        r.then((res) => {
            if (res.error_code === 0) {
                const topAd = res.data[0];
                this.setState({
                    topAd: topAd && topAd.banner_sys_id === "10" ?
                        topAd.banner_info[0].banner_img : "",
                });
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/containers/shop_en/common/header/index.tsx